/** @jsxImportSource @emotion/react */

import { Spin } from "antd";
import PaginationTable from "components/desktop/PaginationTable";
import TableBettingRecord from "components/mobile/TableBettingRecord";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  selectDataBettingRecord,
  selectIsLoadingBettingRecord,
  selectTotalBettingRecord,
  updateCurrentPageBettingRecord,
} from "store/bettingrecord";
import { AppDispatch } from "types";

import EmptyData from "../EmptyData";
import { TableHistoryMobileStyle } from "./style.index";

const TableHistoryMobile = () => {
  const dispatch = useDispatch<AppDispatch>();

  const dataBettingRecord = useSelector(selectDataBettingRecord);
  const isLoadingBettingRecord = useSelector(selectIsLoadingBettingRecord);
  const totalBettingRecord = useSelector(selectTotalBettingRecord);

  const [pageCurrent] = useState<number>(1);

  const renderTableBetRecord = dataBettingRecord.map((itemBet, indexBet) => {
    return (
      <div key={`key-${indexBet}-table-bet`}>
        <TableBettingRecord item={itemBet} />
      </div>
    );
  });

  return (
    <>
      <div css={TableHistoryMobileStyle.wrapper}>
        {dataBettingRecord.length === 0 && isLoadingBettingRecord ? (
          <div css={TableHistoryMobileStyle.loadingData}>
            {Array.from(Array(1), (_, index) => (
              <div key={index}>
                <Spin />
                <span key={index}>Đọc dữ liệu...</span>
              </div>
            ))}
          </div>
        ) : (
          <div>
            {dataBettingRecord &&
            dataBettingRecord.length > 0 &&
            Array.isArray(dataBettingRecord) ? (
              <>{renderTableBetRecord}</>
            ) : (
              <div css={TableHistoryMobileStyle.emptyData}>
                <EmptyData />
                <span>Không có dữ liệu</span>
              </div>
            )}
          </div>
        )}
      </div>
      <PaginationTable
        lengthData={dataBettingRecord?.length || 0}
        page={pageCurrent}
        pageSize={10}
        total={totalBettingRecord}
        onChangePage={(page: number) =>
          dispatch(updateCurrentPageBettingRecord(page))
        }
      />
    </>
  );
};

export default TableHistoryMobile;
